var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    attrs: {
      src: _vm.modpackIcon(_vm.value.icon),
      alt: _vm.value.name,
      loading: "lazy",
      title: _vm.value.name,
    },
    on: { error: _vm.onError },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }